import { useFormikContext } from "formik";
import React from "react";
import styled from "styled-components";
import { CvpButton } from "../../../generic-components/buttons/CvpButton";
import { useLocStore } from "../../../localization";
import { LocContext } from "../../../localization/LocContext";

interface ChosenAttachmentsListProps {
  attachments: File[];
  header?: string;
  otherFieldName?: string;
}

export const ChosenAttachmentsList = (props: ChosenAttachmentsListProps) => {
  const { attachments, header, otherFieldName } = props;
  const L = useLocStore(LocContext.JOB);

  const formik = useFormikContext();

  return (
    <StyledAttachments>
      {header && <h4>{header}</h4>}

      <ul>
        {attachments.map((file, index) => (
          <li key={index}>
            <i className="pi pi-paperclip" />
            <p>{file.name}</p>
            <CvpButton
              type="button" // type button to prevent form submission
              text
              icon="pi pi-times"
              onClick={() => {
                const newAttachments = attachments.filter(
                  (_, i) => i !== index
                );
                formik.setFieldValue(
                  otherFieldName ? otherFieldName : "attachments",
                  newAttachments
                );
              }}
            />
          </li>
        ))}
      </ul>
    </StyledAttachments>
  );
};

export const StyledAttachments = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;

  h4 {
    padding: 0;
    margin: 0;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style-type: none;

    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    i {
      font-size: 1rem;
    }

    p {
      font-size: 0.9rem;
      font-weight: 600;
      margin: 0;
    }

    li {
      display: flex;
      align-items: center;
      gap: 1rem;
      padding: 0;
    }
  }
`;
